var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    viewBox: "0 0 36.95 38"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.03 14.16c-1.74-1.74-3.83-1.93-4.65-1.93h-6.17a1.54 1.54 0 0 0 0 3.08h6.17c.34 0 1.53.07 2.48 1.03.66.66 1.03 1.54 1.03 2.48v12.61c0 1.93-1.57 3.5-3.5 3.5H6.58c-1.93 0-3.5-1.57-3.5-3.5V18.82c0-1.93 1.57-3.5 3.5-3.5h6.38a1.54 1.54 0 0 0 0-3.08H6.58C2.95 12.24 0 15.19 0 18.82v12.61c0 3.63 2.95 6.58 6.58 6.58h23.8c3.63 0 6.58-2.95 6.58-6.58V18.82c0-1.76-.68-3.41-1.93-4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.16 9.96c.39 0 .77-.14 1.07-.43l4.72-4.59v22.11a1.54 1.54 0 0 0 3.08 0V4.79l4.88 4.74c.3.29.68.43 1.07.43s.8-.16 1.1-.47c.59-.61.58-1.58-.03-2.17L19.95.44c-.35-.34-.81-.48-1.26-.42-.07 0-.14-.02-.2-.02h-.14c-.42-.02-.84.12-1.16.43L10.1 7.32c-.61.59-.62 1.56-.03 2.17.3.31.7.47 1.1.47Z"
  }))));
};
export default SvgShare;